import { SvgIcon, SvgIconProps } from "designSystem/index";
import React, { FunctionComponent } from "react";
import { grey } from "designSystem/styles/color";

const FaceSelectBackIcon: FunctionComponent<SvgIconProps> = ({ ...props }) => {
	return (
		<SvgIcon {...props} viewBox="0 0 16 16">
			<rect
				fill={grey[900]}
				height="10.37"
				width="10.37"
				x="4.58"
				y="0.96"
			/>
			<path d="M16,12.38V0H3.61L0,3.62H0V16H12.38L16,12.38Zm-12.38-1L1.46,13.52V5.07H3.62ZM5.07,5.07h5.86v5.86H5.07Zm7.31-.43,2.16-2.16v8.45H12.38Zm1.13-3.18L11.36,3.61H5.07V1.46Zm-9.89.6V3.61H2.06ZM2.49,14.55l2.15-2.17h6.29v2.17Zm9.89-.61V12.38h1.56Z" />
		</SvgIcon>
	);
};

export default FaceSelectBackIcon;